import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'

import Header from './../../inc/Header';
import Footer from './../../inc/Footer';
//import Loader from './../../inc/Loader';
import ScrollToTop from './../../inc/ScrollToTop';
import PhotographyContent from './PhotographyContent';


class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageLoading: true
		}
	}
	componentDidMount() {
		let _this = this;
	}

	render() {
		let _this = this;
		let { menu } = this.props.menu;
	
		return (
			<main className="mole__credits bg-general">
				{/* {this.state.pageLoading &&
					<Loader />
				}  */}
				<ScrollToTop />
                <Link className="btn-menu" exact to={`${process.env.PUBLIC_URL}/credits`}></Link>
                <PhotographyContent/>
			</main>
		);
	}
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Credits/Photography/_index.js